module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/RO-9f34288c347dd00f498d2cbcf04949f6.png";